import { Component, EventEmitter, inject, Inject, Output } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Api } from "../../services/api";
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";


@Component({
    standalone:true,
    selector: 'app-mdl-change-accountOwner',
    imports:[NgSelectModule,FormsModule,CommonModule],
    templateUrl:'./mdl-change-contractOwner.html',
    styleUrls:['./mdl-change-contractOwner.css']
})
export class MdlChangeOwnerContractComponent{
  users: any[] = [];
  selectedOwner: string = '';
  sendEmail: boolean = false;

  contrato: any;
  cuentaAsociada: any;
  @Output() ownerChanged = new EventEmitter<any>();

  private api = inject(Api);
  private mdl = inject(MatDialogRef<MdlChangeOwnerContractComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    console.log('Datos recibidos en modal:', data);

    this.contrato = data.contrato;
    this.cuentaAsociada = this.contrato?.oportunidades?.cuenta;
    console.log('Cuenta asociada:', this.cuentaAsociada);

    this.api.getUsers().subscribe({
      next: (res: any) => {
        this.users = (res.users || []).map((user: any) => ({
          ...user,
          nombreCompleto: `${user.nombre} ${user.apellido}`,
        }));

        const actual = this.users.find(
          (u) => u.usuario_id === this.cuentaAsociada?.ejecutivo_id
        );
        if (actual) {
          this.selectedOwner = actual.usuario_id;
        }
      },
      error: (err) => {
        console.error('Error al cargar usuarios:', err);
        this.users = [];
      },
    });
  }

  get nombreEjecutivoActual(): string {
    const user = this.users.find(
      (u) => u.usuario_id === this.cuentaAsociada?.ejecutivo_id
    );
    return user ? `${user.nombre} ${user.apellido}` : 'Sin asignar';
  }

  saveChange(): void {
    if (!this.selectedOwner || !this.cuentaAsociada?.cuenta_id) {
      console.warn('Falta cuenta_id o propietario nuevo');
      return;
    }

  const payload = {
  cuenta_id: this.cuentaAsociada?.cuenta_id,
  ejecutivo_id: this.selectedOwner,  
};

    console.log('Enviando payload cambio propietario:', payload);

    this.api.changeAccountOwner(payload).subscribe({
      next: (res) => {
        console.log('Propietario cambiado:', res);
        window.alert('Propietario de la cuenta actualizado correctamente');
        this.ownerChanged.emit(res);
        this.mdl.close(res);
      },
      error: (err) => {
        console.error('Error al cambiar propietario:', err);
        window.alert('Error al cambiar el propietario');
        this.mdl.close();
      },
    });
  }

  closeMdl(): void {
    this.mdl.close();
  }
}




    


